import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">51漫画网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              洞洞杂货铺韩漫全集免费阅读平台，每日更新，高清画质，畅享韩漫魅力。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">用户口碑</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">联系我们</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">常见问题</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              &copy; 2020-2026 51漫画网 版权所有 | 洞洞杂货铺韩漫全集免费阅读
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-300 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-300 transition-colors">服务条款</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-300 transition-colors">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}